import { button } from "@/helper/locale/base/base_button.th"
import base_otp from "@/helper/locale/base/base_otp.th"
import { date } from "@/helper/locale/base/base_date.th"

export default {
    base_button: button,
    base_otp,
    base_date: date,

    module: {
        exchange_name: "The 1 Points"
    },

    init: {
        connectTheOne: "Please connect with The1 account",
        theOneNumber: "The1 Number : ",
    },
    buttons: {
        continue: "ไปต่อ",
        backToHome: "กลับสู่หน้าหลัก",
        logout: "ออกจากระบบ",
        tryAgain: "ลองอีกครั้ง"
    },
    convert: {
        title: {
            convert: "โอน",
            textTo: "เป็น"
        },
        theOneNumber: "หมายเลขสมาชิก The 1 : ",
        theOneName: "ชื่อ : ",
        enter: "เบอร์โทรศัพท์ของคุณ",
        contact_number: {
            name: "เบอร์โทรศัพท์ของคุณ",
            placeholder: "",
            required: "Please True number",
            too_short: "",
            invalid: ""
        },
        identifier_no: {
            name: "เบอร์โทรศัพท์ของคุณ",
            placeholder: "",
            required: "",
            too_short: "",
            invalid: ""
        },
        current_point: "{0} ของคุณ",
        after_point: "คะแนนคงเหลือหลังการโอน",
        please_enter: "ระบุ",
        continue: "ดำเนินการต่อ",

        not_found_err_title: "ไม่พบ {0}",
        not_found_err: "{0} {1} ที่ท่านระบุไม่พบว่าเป็นสมาชิกในระบบ</br></br>กรุณากรอก {0} ใหม่อีกครั้ง",
        not_verified_err: "ไม่สามารถทำรายการได้ เนื่องจากบัญชีผู้ใช้งานนี้ยังไม่ยืนยันตัวตน",
        user_account_frozen_err: "ไม่สามารถทำรายการได้เนื่องจากบัญชีผู้ใช้ถูกระงับชั่วคราว",
        exceed_daily_err: "ไม่สามารถทำรายการได้เนื่องบัญชีผู้ใช้งานทำรายการเกินขีดจำกัดแล้วในวันนี้",
        balance_limit_err: "ไม่สามารถทำรายการได้เนื่องจากยอดเงินในบัญชีผู้ใช้ถึงขีดจำกัด",

        update_err_title: "ปรับปรุงข้อมูล {0}",

        convert_err_title: "การโอนคะแนนผิดพลาด",
        convert_err: "กรุณาติดต่อ call center</br>",

        other_err_title: "มีบางอย่างผิดปกติ",
        other_err: "ไม่สามารถทำรายการได้ กรุณาลองใหม่อีกครั้ง",

        point_not_enough_err: "ขออภัย คะแนนของคุณไม่ถึงจำนวนที่กำหนด กรุณาตรวจสอบอีกครั้ง",
        topup_too_high: "ไม่สามารถทำรายการได้เนื่องจากยอดเติมเงินสูงเกินกำหนด",
        topup_too_low: "ไม่สามารถทำรายการได้เนื่องจากยอดเติมเงินต่ำเกินกำหนด",

        re_enter: "ใส่ข้อมูลใหม่",
        close: "ปิด",
        back_to_campaign: "กลับสู่หน้าแคมเปญ",

        retry: "ลองอีกครั้ง",
        back: "กลับ"
    },
    result: {
        successfully: "การโอนคะแนนสำเร็จ",
        new_point: "New {0}",
        your_convert: "คุณได้โอน",
        please_check_balance: "กรุณาตรวจสอบยอดเงินคงเหลือของคุณผ่าน ShopeePay Application",
        back_to_campaign: "กลับสู่หน้าหลัก"
    },
    confirm: {
        title: "ยืนยันการโอนคะแนน",
        member: "สมาชิก",
        warning_text: "เมื่อยืนยันการโอนคะแนนแล้วไม่สามารถยกเลิกได้",
        submit: "ยืนยัน",
        cancel: "ยกเลิก"
    },
    otp: {
        headline: 'การยืนยัน OTP',
        contact_number_lbl: 'เราได้ส่ง OTP ไปยังหมายเลข<br/>{0}',
        ref_code: 'หมายเลขอ้างอิง : ',

        please_enter_otp: 'กรุณากรอกรหัส OTP',
        time_left: 'ส่ง OTP อีกครั้งได้ภายใน',
        second: 'นาที',

        required: 'Please enter your OTP.',
        too_short: 'Please enter otp',
        otp_timeout: 'OTP time out in',
        resend_otp: 'ส่ง OTP อีกครั้ง',

        incorrect_otp: 'รหัส OTP ไม่ถูกต้อง กรุณาลองใหม่อีกครั้ง',
        cancel: "ยกเลิก",
        btn_confirm: "ยืนยันและทำการโอนคะแนน"
    },
    errors: {
        pointConversionError: {
            title: "การโอนคะแนนผิดพลาด",
            message: "รบกวนติดต่อศูนย์บริการ <br /> {0}"
        },
        somethingWrong: {
            title: "เกิดข้อผิดพลาด",
            message: "ไม่สามารถทำรายการได้<br />กรุณาลองใหม่อีกครั้ง"
        },
        login: {
            title: "เข้าสู่ระบบไม่สำเร็จ",
            message: "รบกวนติดต่อศูนย์บริการ<br />02-660-1000"
        },
        accountBlocked: {
            message: "บัญชีของคุณถูกจำกัดการเข้าใช้งาน <br />กรุณาติดต่อติดต่อศูนย์บริการ<br />{0}"
        },
        fullQuota: {
            title: "เกิดข้อผิดพลาด",
            message: "บัญชีของคุณครบกำหนดการแลกพอยท์แล้ว<br />กรุณาลองใหม่อีกครั้งในเดือนถัดไป"
        }
    },
    logout: {
        title: "ยืนยันการออกจากระบบ",
        text: "กด ยืนยัน เพื่อออกจากระบบ",
        btnOk: "ยืนยัน",
        btnCancel: "ยกเลิก"
    },
    login: {
        btnLogin: "เข้าสู่ระบบ The 1",
    }
}
